/**
 * AWS Cognito Configuration
 *
 * This file contains the Cognito User Pool configuration for authentication.
 * Configuration values are loaded from environment variables.
 */

export interface CognitoConfig {
  userPoolId: string;
  clientId: string;
  region: string;
  hostedUIDomain: string;
}

/**
 * Get Cognito configuration from environment variables.
 * Falls back to dev values for local development.
 */
export const getCognitoConfig = (): CognitoConfig => {
  const config = {
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
    clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
    region: process.env.REACT_APP_AWS_REGION || 'ap-southeast-1',
    hostedUIDomain: process.env.REACT_APP_COGNITO_DOMAIN || '',
  };

  // Validate configuration
  if (!config.userPoolId || !config.clientId || !config.hostedUIDomain) {
    console.error('Missing Cognito configuration. Ensure REACT_APP_COGNITO_USER_POOL_ID, REACT_APP_COGNITO_CLIENT_ID, and REACT_APP_COGNITO_DOMAIN are set.');
  }

  return config;
};

// Export singleton config instance
export const cognitoConfig = getCognitoConfig();
